import React, { useEffect, useState } from "react";
import axios from "axios";

const PopupNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seenPopup = localStorage.getItem("hasSeenPopup");
    if (!seenPopup) {
      setTimeout(() => setShow(true), 100); // Delay for smoother experience
    }
  }, []);

  const handleOkClick = async () => {
    setShow(false);
    localStorage.setItem("hasSeenPopup", "true");

    try {
      await axios.post("/api/log-visit/", {
        time: new Date().toISOString(),
      });
    } catch (err) {
      console.error("Error logging visit:", err);
    }
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "24px",
          width: "90%",
          maxWidth: "420px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
          transform: "scale(1)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <h2
          style={{
            fontSize: "20px",
            fontWeight: 600,
            color: "#1f2937",
            marginBottom: "12px",
            textAlign: "center",
          }}
        >
          🚧 Hey There !!
        </h2>
        <p
          style={{
            fontSize: "14px",
            color: "#374151",
            textAlign: "center",
            lineHeight: 1.6,
            marginBottom: "20px",
          }}
        >
          {/*This website is still implementing new functionalities. Some links may not work, but the data shown in working sections is <strong>live</strong> and <strong>accurate</strong>.*/}
          We are constantly adding new features to bring you analytics and insights based on data which is <strong>live</strong> and <strong>accurate</strong>.
          <br />
          <br />
          <span style={{ fontWeight: "600", color: "#4B5563" }}>
            Thanks for your understanding!
          </span>
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={handleOkClick}
            style={{
              backgroundColor: "#2563EB",
              color: "#fff",
              padding: "10px 24px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.target.style.backgroundColor = "#1D4ED8")
            }
            onMouseOut={(e) =>
              (e.target.style.backgroundColor = "#2563EB")
            }
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupNotice;